module.exports = __webpack_public_path__ + "static/media/background-2-960w.39b4d88f.webp";